import React, { useState, useEffect } from 'react';
import { Modal, Box, Button, Typography, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';

const AccountAssignCategoryModalBulk = ({ open, onClose, account, render, setRender }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const ToasterToggle = JSON.parse(localStorage.getItem("Toaster"))
    useEffect(() => {
        if (open) {
            const token = localStorage.getItem('token');
            axios.get(`${process.env.REACT_APP_BASE_URL}category/all`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then((response) => {

                    setCategories(response.data);
                })
                .catch((error) => console.error("Failed to fetch categories:", error));
        }
    }, [open]);

    const handleAssign = () => {
        const token = localStorage.getItem('token');
        axios.post(`${process.env.REACT_APP_BASE_URL}category/assign-bulk`,{     
            accountIds: account,
            categoryId: selectedCategory
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }},
         ).then((res) => {
            if (ToasterToggle) {
                toast.success(res.data.message || 'Account assigned to category successfully');
            }
            setRender(!render);
            onClose();
        }).catch((error) => {
            if (ToasterToggle) {
                toast.error(error.response.data.message || 'Failed to assign Account to category');
            } console.error(error);
        });
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                borderRadius: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}>
                <Typography variant="h6" sx={{ color: "black" }}>Assign Account to Category</Typography>
                <FormControl fullWidth>
                    <InputLabel>Select Category</InputLabel>
                    <Select
                        value={selectedCategory}
                        label="Select Category"
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                        {categories?.map((category) => (
                            <MenuItem key={category._id} value={category._id}>{category.categoryName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Button variant="contained" onClick={handleAssign}>Assign</Button>
            </Box>
        </Modal>
    );
};

export default AccountAssignCategoryModalBulk;
